import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/visibility.svg` */
export const VisibilityIcon = createTripletGlyphIcon('VisibilityIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99951 4.60535C9.59332 4.60537 10.8853 5.89727 10.8853 7.49109C10.8851 9.08475 9.59321 10.3768 7.99951 10.3768C6.40588 10.3767 5.11396 9.0847 5.11377 7.49109C5.11377 5.89732 6.40576 4.60545 7.99951 4.60535ZM7.99951 5.70496C7.01327 5.70505 6.21338 6.50483 6.21338 7.49109C6.21357 8.47719 7.01339 9.27712 7.99951 9.27722C8.98569 9.2772 9.78545 8.47723 9.78564 7.49109C9.78564 6.50478 8.98581 5.70498 7.99951 5.70496Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20654 2.93152C12.2891 2.93189 14.244 5.94655 14.7466 7.30164L14.8169 7.49304L14.7466 7.68445C14.2439 9.03957 12.289 12.0542 8.20654 12.0546C4.20065 12.0547 1.92304 9.28973 1.26904 7.70203L1.18311 7.49304L1.26904 7.28308C1.9232 5.69533 4.2009 2.93136 8.20654 2.93152ZM8.20654 4.03113C4.93892 4.031 3.02592 6.17014 2.38232 7.49207C3.0252 8.81388 4.93767 10.9551 8.20654 10.955C11.4681 10.9546 13.1175 8.68262 13.6362 7.49304C13.1175 6.30348 11.4682 4.03147 8.20654 4.03113Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.26807 5.78894C10.5929 5.92362 11.6273 7.04282 11.6274 8.4032L11.6138 8.67175C11.4792 9.99678 10.36 11.0309 8.99951 11.0311L8.73096 11.0175C7.49407 10.8919 6.51083 9.90863 6.38525 8.67175L6.37158 8.4032C6.37178 6.95203 7.5483 5.77527 8.99951 5.77527L9.26807 5.78894ZM8.99951 6.87488C8.15581 6.87488 7.47139 7.55954 7.47119 8.4032C7.47122 9.247 8.1557 9.93054 8.99951 9.93054C9.84313 9.93032 10.5268 9.24686 10.5269 8.4032C10.5267 7.55968 9.84302 6.8751 8.99951 6.87488Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23096 3.34265C13.7845 3.34283 15.965 6.70616 16.5249 8.2157L16.5952 8.40613L16.5249 8.59753C15.9648 10.1073 13.7841 13.4694 9.23096 13.4696C4.75979 13.4696 2.21902 10.3837 1.49072 8.61609L1.40479 8.40613L1.49072 8.19714C2.21879 6.42962 4.75943 3.34265 9.23096 3.34265ZM9.23096 4.44324C5.49751 4.44323 3.32131 6.9034 2.60303 8.40613C3.32115 9.90883 5.49725 12.37 9.23096 12.37C12.9623 12.3698 14.8373 9.75258 15.4146 8.40613C14.8371 7.05957 12.9619 4.44339 9.23096 4.44324Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.999 6.94507C14.3478 6.94523 16.2527 8.84878 16.2529 11.198C16.2529 13.4739 14.4653 15.3321 12.2178 15.446L11.999 15.4519C9.64969 15.4519 7.74512 13.5473 7.74512 11.198C7.7454 8.84875 9.65002 6.94507 11.999 6.94507ZM11.999 8.44507C10.4781 8.44507 9.24535 9.67745 9.24512 11.198C9.24512 12.7189 10.4781 13.9519 11.999 13.9519L12.2803 13.9373C13.669 13.7962 14.7529 12.6238 14.7529 11.198C14.7527 9.77253 13.669 8.60067 12.2803 8.45972L11.999 8.44507Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3086 4.43433C18.3895 4.43466 21.301 8.92482 22.0488 10.9412L22.1455 11.2019L22.0488 11.4626C21.301 13.479 18.3895 17.9692 12.3086 17.9695C6.33824 17.9697 2.94557 13.8494 1.97266 11.488L1.85449 11.2019L1.97266 10.9158C2.94555 8.55442 6.3382 4.4341 12.3086 4.43433ZM12.3086 5.93433C7.34323 5.93413 4.44581 9.20208 3.4873 11.2019C4.44584 13.2017 7.34328 16.4697 12.3086 16.4695C17.2687 16.4692 19.7639 12.9952 20.5352 11.2019C19.7639 9.40861 17.2687 5.93462 12.3086 5.93433Z"
        fill="currentColor"
      />
    </svg>
  ),
});
